import React from 'react';
import { VictoryBar } from 'victory';
import { ChartDataPoint } from '../../axisUtils';

interface BarProps {
  data: ChartDataPoint[],
  fill: string,
  activeFill: string,
  cornerRadius?: number,
}

const Bar = ({
  data, fill, activeFill, cornerRadius,
}: BarProps) => <VictoryBar
    {...{ data }}
    style={{
      data: { fill: ({ active }: { active: boolean }) => (active ? activeFill : fill) },
    }}
    cornerRadius={{ topLeft: cornerRadius, topRight: cornerRadius }}
    x='index'
    y='value'
    barRatio={0.9}
  />;

export default Bar;
